import { Checkbox, CityState, DataSource, HorizontalSpacer, Layout, Location, Panel, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderList extends Layout {
    checkboxPreloaded: Checkbox;
    citystateStopDestCityId: CityState;
    citystateStopOriginCityId: CityState;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacerLocation: HorizontalSpacer;
    panelAssetFields: Panel;
    panelConsigneeLocation: Panel;
    panelOrderContainer: Panel;
    panelOrderListContainer: Panel;
    panelOrderSearch: Panel;
    panelShipperLocation: Panel;
    searchOrders: SearchPanel;
    sourceOrdersList: DataSource;
    switchCheckHazmat: Switch;
    switchIntercompany: Switch;
    switchInvoiced: Switch;
    tableOrders: Table;
    textboxCustomerId: Textbox;
    textboxDeliveryDateRange: Textbox;
    textboxDestLocation: Location;
    textboxEnteredUserId: Textbox;
    textboxEquipmentTypeId: Textbox;
    textboxId: Textbox;
    textboxInvoiceDate: Textbox;
    textboxInvoiceNumber: Textbox;
    textboxMovementType: Textbox;
    textboxOrderMode: Textbox;
    textboxOrderStatus: Textbox;
    textboxOrderTypeId: Textbox;
    textboxOrderedDate: Textbox;
    textboxOriginLocation: Location;
    textboxPickupDateRange: Textbox;
    textboxRateId: Textbox;
    textboxRecurringOrderId: Textbox;
    textboxReferenceNumbers: Textbox;
    textboxRevenueCodeId: Textbox;
    textboxStopDestAddress2: Textbox;
    textboxStopDestAddress: Textbox;
    textboxStopDestLocationId: Textbox;
    textboxStopDestLocationName: Textbox;
    textboxStopOriginAddress2: Textbox;
    textboxStopOriginAddress: Textbox;
    textboxStopOriginLocationId: Textbox;
    textboxStopOriginLocationName: Textbox;
    textboxTractorFleetId: Textbox;
}
